
import styled from "styled-components";

export const ContactWrapper = styled.div`
  display: grid;
  grid-template-columns: 18% 79%;
  column-gap: 3%;
  align-items: start;
  border-bottom: 1px solid #eaeaea;
  text-align: left;
  padding-bottom: 8px;

  label {
    text-transform: capitalize;
    margin-bottom: 4px;
  }

  @media (max-width: 576px) {
    grid-template-columns: 100%;
    row-gap: 6px;
  }
`;

export const ContactInputWrapper = styled.div`
  display: grid;
  grid-template-columns: 48% 48%;
  column-gap: 4%;
  align-items: center;

  .input-group-text {
    padding: 0 6px;
    border-right: 1px solid #eee;
  }

  @media (max-width: 768px) {
    grid-template-columns: 100%;
    row-gap: 8px;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 0.4rem 0.6rem;
  font-size: 13px;
  border: 1px solid #eaeaea;
  border-right: 0;
  outline: none;
  background: #fff;

  &:focus-visible {
    box-shadow: 0 0 0 0.2rem rgb(13 110 253 / 15%);
  }
`;

export const ContactText = styled.div`
  padding: 8px 0;
  font-size: 11px;
  line-height: 1.4;
  text-align: left;
`;

export const UserContactWrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;

  select {
    width: 40%;
    min-width: 75px;
  }
`;

export const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  margin-bottom: 8px;
  font-size: 12px;
`;

export const LoginText = styled.div`
  color: ${(props) => props.textcolor};
  transition: color 0.2s ease;
  cursor: pointer;
  margin-left: 6px;

  &:hover {
    color: ${(props) => props.texthvcolor};
  }
`;
